import React from 'react';
import {makeStyles, Theme} from '@material-ui/core/styles';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import {useTheme} from '@material-ui/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        borderWidth: 0,
        textAlign: 'center',
        padding: 0,
        backgroundColor: theme.palette.white,
        color: theme.palette.black,

        '& .MuiInputBase-input': {
            padding: 0,
            textAlign: 'center'
        },

        '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderRadius: 0,
            borderColor: theme.palette.secondary.main,
        },
        '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.secondary.main,
        },
        '&.MuiOutlinedInput-root:active .MuiOutlinedInput-notchedOutline': {
            borderTopWidth: 0,
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderColor: theme.palette.secondary.main,
        },
        '&.MuiOutlinedInput-root:focus .MuiOutlinedInput-notchedOutline': {
            borderWidth: 0,
            borderColor: theme.palette.secondary.main,
        },
    },
    isEmpty: {
        '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
            borderColor: '#B2B2B2',
        },
        '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#B2B2B2',
        },
        '&.MuiOutlinedInput-root:active .MuiOutlinedInput-notchedOutline': {
            borderColor: '#B2B2B2',
        },
        '&.MuiOutlinedInput-root:focus .MuiOutlinedInput-notchedOutline': {
            borderColor: '#B2B2B2',
        },
    },
    hideZero: {
        color: theme.palette.white,
    },
    iconButton: {
        borderRadius: 0,
        color: theme.palette.white,
        padding: 2,
        fontSize: 20,
        backgroundColor: theme.palette.secondary.main,

        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
        },
        '&:active': {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
    emptyButton: {
        backgroundColor: '#B2B2B2',

        '&:hover': {
            backgroundColor: '#B2B2B2',
        },
        '&:active': {
            backgroundColor: '#B2B2B2',
        },
    }
}));

interface Props {
    value: number;
    min: number;
    max: number;
    onChange: (value: number) => void;
    disabled?: boolean;
    hideZero?: boolean;
};

export const NumberSpinner = (props: Props) => {
    const classes = useStyles();
    const isEmpty = props.value === 0;

    const newValue = (val: number) => {
        if (val >= props.min && val <= props.max) {
            props.onChange(val);
        }
    };

    return (
        <OutlinedInput
            value={props.value}
            className={clsx(
                classes.root,
                isEmpty && classes.isEmpty,
                isEmpty && props.hideZero && classes.hideZero,
            )}
            labelWidth={0}
            readOnly
            startAdornment={
                <IconButton
                    className={clsx(classes.iconButton, isEmpty && classes.emptyButton)}
                    onClick={() => newValue(props.value - 1)}
                    disabled={props.disabled}
                >
                    <RemoveIcon/>
                </IconButton>
            }
            endAdornment={
                <IconButton
                    className={clsx(classes.iconButton, isEmpty && classes.emptyButton)}
                    onClick={() => newValue(props.value + 1)}
                    disabled={props.disabled}
                >
                    <AddIcon/>
                </IconButton>
            }
        />
    );
};

export default NumberSpinner;
